import {CustomerProfile} from "../../../entities/UserProfile";
import {createContext, useContext} from "react";

export const ClientProfileContext = createContext<CustomerProfile>({} as CustomerProfile);
export const useClientProfile = () => useContext(ClientProfileContext);
